import classNames from 'classnames';
import React from 'react';
import { Scrollbars } from '@meitu/saas-ui';
import { type IAdvancedTextMaterial, type ITextLayerProps } from '@meitu/saas-editor-core/es/version-types';
import IconFont from '@meitu/xdesign-icon-font';
import { useEditor } from '@/hooks/use-editor';
import { type ArtTextStruct } from '@/types';
import { useLayerProps } from '../../hooks';
import { Tracker } from '../../utils';
import './art-text-panel.less';
import { TextLayerExtension } from '@meitu/saas-editor-core/es/editor/layer-extensions/text-layer';

type Props = {
    layerId: string;
    recordId?: number;
    theme: string;
    artTexts: ArtTextStruct[];
};

export const ArtTextPanel: React.FC<Props> = ({ layerId, recordId, artTexts }) => {
    const editor = useEditor();

    const props = useLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as ITextLayerProps;
        const { advancedTextMaterial } = layerData;

        return {
            advancedTextMaterial,
        };
    });

    const advancedTextMaterial = props?.advancedTextMaterial;

    const renderCornerIcon = (cornerMark: ArtTextStruct['cornerMark']) => {
        return <img className="art-text-panel__corner-icon" src={cornerMark!.url} />;
    };

    const applyArtText = (data: IAdvancedTextMaterial) => {
        editor.getInstance(TextLayerExtension).applyArtText(layerId, data);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        Tracker.useArtText({
            recordId,
            stageType: editor.stage.getType(),
            id: data.id,
        });
    };

    const cancelArtText = () => {
        editor.getInstance(TextLayerExtension).cancelArtText(layerId);
    };

    return (
        <Scrollbars>
            <div className="art-text-panel">
                <div
                    className={classNames('art-text-panel__item', {
                        'art-text-panel__item--cancel': true,
                    })}
                    onClick={cancelArtText}
                >
                    <IconFont name="SlashCircleBold" fontSize={28} />
                </div>

                {artTexts.map((item) => {
                    const cover = item.thumbnail.url;

                    return (
                        <div
                            key={item.id}
                            className={classNames('art-text-panel__item', {
                                'art-text-panel__item--active':
                                    advancedTextMaterial && advancedTextMaterial.id === item.id,
                            })}
                            onClick={() => applyArtText(item.config)}
                        >
                            <img className="art-text-panel__cover" src={cover} />
                            {item.cornerMark ? renderCornerIcon(item.cornerMark) : null}
                        </div>
                    );
                })}
            </div>
        </Scrollbars>
    );
};
